import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { FormControl, FormsModule, Validators } from '@angular/forms';
import { NodeFieldsDataService } from '../../services/data.service';
import { MaterialModule } from '../../../../../../../modules/catch-core/third-party/material/material.module';

@Component({
  selector: 'app-add-dialog',
  templateUrl: './add-dialog.component.html',
  styleUrls: ['./add-dialog.component.css'],
  standalone: false,
})
export class NodeFieldAddDialogComponent {
  public columnConfigurations = [];
  public selectedField = '';
  // public fieldLabel = '';
  public fieldList: any = [];
  public formControl = new FormControl('', [Validators.required]);
  @ViewChild(MatSelect, { static: true }) fieldSelect!: MatSelect;

  constructor(
    public dialogRef: MatDialogRef<NodeFieldAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: NodeFieldsDataService,
  ) {
    this.columnConfigurations = dataService.getTableConfiguration();
    this.fieldList = this.constructFieldList();
  }

  public closeOption() {
    this.fieldSelect.close();
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    const newTableColumnDataRow: { [key: string]: string } = {};
    newTableColumnDataRow['field'] = this.selectedField;
    // newTableColumnDataRow['fieldLabel'] = this.fieldLabel;
    this.dataService.addRecord(newTableColumnDataRow);
  }

  public dataTypeSelection(datatype: string) {
    this.selectedField = datatype;
  }

  private constructFieldList(): any[] {
    const currentRecordList = this.dataService.getAllCurrentData();
    const fieldsNotAssign = [];

    // if empty field binding
    if (currentRecordList.length === 0) {
      return this.columnConfigurations[0]['options'];
    }

    const allFieldList = this.dataService.getDeepCopy(this.columnConfigurations[0]['options']);
    currentRecordList.forEach((currentField) => {
      for (const key in allFieldList) {
        if (allFieldList.hasOwnProperty(key)) {
          if (allFieldList[key]['id'] === currentField['field']['id']) {
            allFieldList.splice(key, 1);
          }
        }
      }
    });
    return allFieldList;
  }
}
